import { assert } from '../../../lib/assert-sidecar'
import { l } from '../../../lib/imports'
import { voyageCrew } from '../voyageCrew-sidecar'
import { voyageTilemap } from '../voyageTilemap-sidecar'
import { voyageWebsockets } from '../voyageWebsockets-sidecar'
import { EVoyageMessage } from './voyageMessageIds'
import { EInfoRequestType } from './voyageMessageInfoRequest'
import type { IMessageWriter } from '../../../engine/messageWriter'
import { messageWriter } from '../../../engine/messageWriter-sidecar'
import { websockets } from '../../../engine/websockets-sidecar'

export interface IMessageInfoSend {
  type: EInfoRequestType
  crewId: number
  systemId: number
  name: string
  title: string
  info1: string
}

export const voyageMessageId = EVoyageMessage.InfoSend

export function write(m: IMessageWriter, d: IMessageInfoSend) {
  messageWriter.write8(m, voyageMessageId)
  messageWriter.write8(m, d.type)
  messageWriter.write32(m, d.crewId)
  messageWriter.write32(m, d.systemId)
  messageWriter.writeString(m, d.name)
  messageWriter.writeString(m, d.title)
  messageWriter.writeString(m, d.info1)
}

export function read(m: IMessageWriter) {
  let t = messageWriter.read8(m)
  assert.eq(t, voyageMessageId)
  let d: IMessageInfoSend = {
    type: messageWriter.read8(m),
    crewId: messageWriter.read32(m),
    systemId: messageWriter.read32(m),
    name: messageWriter.readString(m),
    title: messageWriter.readString(m),
    info1: messageWriter.readString(m),
  }
  return d
}

export function test() {
  let ex: IMessageInfoSend = {
    type: EInfoRequestType.Crew,
    crewId: 120,
    systemId: 435,
    name: 'Tommy mctomson',
    info1: 'some info',
    title: 'testmember',
  }
  messageWriter.test('info-send', ex, write, read)
}

export function process(m: IMessageWriter) {
  let msg = read(m)

  if (!voyageWebsockets.getIsHost()) {
    if (msg.type === EInfoRequestType.Crew) {
      let cr = voyageCrew.findById(msg.crewId)
      assert.notNil(cr)
      cr.info1 = msg.info1
      cr.title = msg.title
      cr.name = msg.name
      cr.requestedInfo = true
    }
    if (msg.type === EInfoRequestType.System) {
      let sys = voyageTilemap.getSystemById(msg.systemId)
      assert.notNil(sys.system)
      sys.system.requestedInfo = true
      sys.system.nickname = msg.name
    }
  }
}

export function sendMessageAndImmediatelyExecute(msg: IMessageInfoSend) {
  websockets._sendMessageAndImmediatelyExecute(write, msg)
}
